import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { urlTimeSheetService } from '@src/endpoints'
import { getUriParams } from '@src/utility/Utils'

export const getExceptionReportData = createAsyncThunk(
  'hrmTSExceptionReport/getExceptionReportData',
  async params => {
    const uri = getUriParams(params)

    let formattedStartDateTime = params.startDateTime
    let formattedEndDateTime = params.endDateTime

    if (params.startDateTime instanceof Date) {
      formattedStartDateTime = params.startDateTime.toISOString()
    }
    if (params.endDateTime instanceof Date) {
      formattedEndDateTime = params.endDateTime.toISOString()
    }

    const FilterModel = {
      profileId: params.profileId || null,
      userId: params.userId || null,
      startDateTime: formattedStartDateTime || null,
      endDateTime: formattedEndDateTime || null,
      deviceName: params.deviceName || null,
      companyId: params.companyId || null
    }

    const response = await axios.post(
      `${urlTimeSheetService}/GetTimeSheetExceptionReport?${uri}`,
      FilterModel
    )

    return {
      params,
      data: response.data,
      totalPages: response.data.length > 0 ? response.data[0].totalCount : 0,
      loadedExceptionReport: true
    }
  }
)

export const getAllEmployeesSelect = createAsyncThunk(
  'hrmTSExceptionReport/getAllEmployeesSelect',
  async () => {
    const response = await axios.get(`${urlTimeSheetService}/GetAllEmployeesSelect`)
    return [{ value: null, label: 'Select...' }, ...response.data.data]
  }
)

export const updateTimesheetExceptionStatus = async statusUpdateModel => {
  await axios.post(`${urlTimeSheetService}/UpdateTimeSheetStatus`, statusUpdateModel)
  return statusUpdateModel
}

export const hrmTSExceptionReportSlice = createSlice({
  name: 'hrmTSExceptionReport',
  initialState: {
    exceptionReportData: [],
    exceptionReportTotal: 0,
    loadedExceptionReport: false,
    allEmployees: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getExceptionReportData.pending, state => {
        state.loadedExceptionReport = false
      })
      .addCase(getExceptionReportData.fulfilled, (state, action) => {
        state.loadedExceptionReport = action.payload.loadedExceptionReport
        state.exceptionReportData = action.payload.data
        state.exceptionReportTotal = action.payload.totalPages
      })
      .addCase(getAllEmployeesSelect.fulfilled, (state, action) => {
        state.allEmployees = action.payload
      })
  }
})

export default hrmTSExceptionReportSlice.reducer
